"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDetailsScreen = void 0;
var react_1 = __importStar(require("react"));
var AccountDetailsScreen_1 = require("../AccountDetailsScreen");
var contexts_1 = require("../../contexts");
var useErrorManager_1 = require("../../contexts/ErrorContext/useErrorManager");
var react_i18next_1 = require("react-i18next");
/**
 * Component renders a screen with account details information for support with the application.
 * Contact information is pulled from the context passed into the workflow.
 *
 * @param firstNameLabel label for the first name text field
 * @param initialFirstName initial value for the first name text field
 * @param firstNameValidator function that validates the first name text field
 * @param firstNameTextFieldProps props to pass to the first name field
 * @param lastNameLabel label for the last name text field
 * @param initialLastName initial value for the last name text field
 * @param lastNameValidator function that validates the last name text field
 * @param lastNameTextFieldProps props to pass to the last name field
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 *
 * @category Component
 */
var AccountDetailsScreen = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var actions = (0, contexts_1.useRegistrationContext)().actions;
    var regWorkflow = (0, contexts_1.useRegistrationWorkflowContext)();
    var nextScreen = regWorkflow.nextScreen, previousScreen = regWorkflow.previousScreen, screenData = regWorkflow.screenData, currentScreen = regWorkflow.currentScreen, totalScreens = regWorkflow.totalScreens;
    var _a = (0, react_1.useState)(screenData.AccountDetails.firstName), firstName = _a[0], setFirstName = _a[1];
    var _b = (0, react_1.useState)(screenData.AccountDetails.lastName), lastName = _b[0], setLastName = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, useErrorManager_1.useErrorManager)(), triggerError = _d.triggerError, errorManagerConfig = _d.errorManagerConfig;
    var errorDisplayConfig = __assign(__assign(__assign({}, errorManagerConfig), props.errorDisplayConfig), { onClose: function () {
            if (props.errorDisplayConfig && props.errorDisplayConfig.onClose)
                props.errorDisplayConfig.onClose();
            if (errorManagerConfig.onClose)
                errorManagerConfig === null || errorManagerConfig === void 0 ? void 0 : errorManagerConfig.onClose();
        } });
    var onNext = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, ((_a = actions === null || actions === void 0 ? void 0 : actions.setAccountDetails) === null || _a === void 0 ? void 0 : _a.call(actions, { firstName: firstName, lastName: lastName }))];
                case 1:
                    _b.sent();
                    void nextScreen({
                        screenId: 'AccountDetails',
                        values: { firstName: firstName, lastName: lastName },
                    });
                    return [3 /*break*/, 4];
                case 2:
                    _error_1 = _b.sent();
                    triggerError(_error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [actions, firstName, lastName, nextScreen, triggerError]);
    var onPrevious = (0, react_1.useCallback)(function () {
        previousScreen({
            screenId: 'AccountDetails',
            values: { firstName: firstName, lastName: lastName },
        });
    }, [firstName, lastName, previousScreen]);
    var WorkflowCardHeaderProps = props.WorkflowCardHeaderProps, WorkflowCardInstructionProps = props.WorkflowCardInstructionProps, WorkflowCardActionsProps = props.WorkflowCardActionsProps, WorkflowCardBaseProps = props.WorkflowCardBaseProps, _e = props.firstNameLabel, firstNameLabel = _e === void 0 ? t('bluiCommon:FORMS.FIRST_NAME') : _e, _f = props.lastNameLabel, lastNameLabel = _f === void 0 ? t('bluiCommon:FORMS.LAST_NAME') : _f, _g = props.firstNameValidator, firstNameValidator = _g === void 0 ? function (name) {
        if ((name === null || name === void 0 ? void 0 : name.length) > 0) {
            return true;
        }
        return t('bluiCommon:FORMS.FIRST_NAME_LENGTH_ERROR');
    } : _g, _h = props.lastNameValidator, lastNameValidator = _h === void 0 ? function (name) {
        if ((name === null || name === void 0 ? void 0 : name.length) > 0) {
            return true;
        }
        return t('bluiCommon:FORMS.LAST_NAME_LENGTH_ERROR');
    } : _h, firstNameTextFieldProps = props.firstNameTextFieldProps, lastNameTextFieldProps = props.lastNameTextFieldProps, _j = props.initialFirstName, initialFirstName = _j === void 0 ? screenData.AccountDetails.firstName : _j, _k = props.initialLastName, initialLastName = _k === void 0 ? screenData.AccountDetails.lastName : _k;
    var workflowCardHeaderProps = __assign({ title: t('bluiRegistration:REGISTRATION.STEPS.ACCOUNT_DETAILS') }, WorkflowCardHeaderProps);
    var workflowCardInstructionProps = __assign({ instructions: t('bluiRegistration:REGISTRATION.INSTRUCTIONS.ACCOUNT_DETAILS') }, WorkflowCardInstructionProps);
    var workflowCardBaseProps = __assign({ loading: isLoading }, WorkflowCardBaseProps);
    var workflowCardActionsProps = __assign(__assign({ canGoNext: true, showNext: true, showPrevious: true, nextLabel: t('bluiCommon:ACTIONS.NEXT'), previousLabel: t('bluiCommon:ACTIONS.BACK'), totalSteps: totalScreens, currentStep: currentScreen }, WorkflowCardActionsProps), { onNext: function () {
            var _a;
            void onNext();
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        }, onPrevious: function () {
            var _a;
            void onPrevious();
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onPrevious) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        } });
    var onFirstNameInputChange = function (e) {
        setFirstName(e.target.value);
    };
    var onLastNameInputChange = function (e) {
        setLastName(e.target.value);
    };
    return (react_1.default.createElement(AccountDetailsScreen_1.AccountDetailsScreenBase, { WorkflowCardBaseProps: workflowCardBaseProps, WorkflowCardHeaderProps: workflowCardHeaderProps, WorkflowCardInstructionProps: workflowCardInstructionProps, initialFirstName: firstName.length > 0 ? firstName : initialFirstName, initialLastName: lastName.length > 0 ? lastName : initialLastName, firstNameLabel: firstNameLabel, firstNameTextFieldProps: __assign(__assign({}, firstNameTextFieldProps), { onChange: onFirstNameInputChange }), firstNameValidator: firstNameValidator, lastNameLabel: lastNameLabel, lastNameTextFieldProps: __assign(__assign({}, lastNameTextFieldProps), { onChange: onLastNameInputChange }), lastNameValidator: lastNameValidator, WorkflowCardActionsProps: workflowCardActionsProps, errorDisplayConfig: errorDisplayConfig }));
};
exports.AccountDetailsScreen = AccountDetailsScreen;
